<template>
  <div class="customer-detail">
    <div class="breadcrumb">
      <i class="el-icon-arrow-left"></i>
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>客户管理</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ name: 'customerDetail' }">服务使用信息</el-breadcrumb-item>
        <el-breadcrumb-item>结算详情</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="line"></div>
    <div class="content">
      <div class="back">
        <span class="left"> 结算详情</span>
        <span class="go-back" @click="goBack">返回</span>
      </div>
    </div>
    <table class="p-table" border="0" cellspacing="0" cellpadding="0">
      <tr>
        <td class="title">业务名称</td>
        <td class="content">{{form.busiDetailType | formatBusiDetailType}}</td>
        <td class="title">累计使用次数</td>
        <!-- <td class="content">{{form.packageNum -  form.remainNo}}</td> -->
        <td class="content">{{form.usedNo}}</td>
      </tr>
      <tr>
        <td class="title">单价</td>
        <td class="content">{{form.packageUnit}}元</td>
        <td class="title">应付总金额</td>
        <td class="content">{{form.totalMoney}}元</td>
      </tr>
      <tr>
        <td class="title">结算周期</td>
        <td class="content">{{form.packageCycle}}个月</td>
        <td class="title">开始时间</td>
        <td class="content">{{form.createTime}}</td>
      </tr>
      <tr>
        <td class="title">结算时间</td>
        <td class="content">{{form.modifyTime}}</td>
        <td class="title">实际支付金额</td>
        <td class="content">{{form.payMoney}}元</td>
      </tr>
      <tr>
        <td class="title">结算状态</td>
        <td class="content">{{form.packageFinanceState | formatPackageFinanceState}}</td>
        <td class="title">支付方式</td>
        <td class="content">{{form.payType | formatPayType}}</td>
      </tr>
      <tr>
        <td class="title">备注</td>
        <td class="content" colspan="3">
          {{form.memo}}
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
import Api from '@/api'
import { statusCode } from '@/config'
import { setStorageItem, getStorageItem, removeStorageItem } from '@/utils'

export default {
  name: 'PackageDetail',
  components: {
  },
  data() {
    return {
    }
  },
  created() {
     this.form = getStorageItem('packageDetail')
  },
  methods: {
    goBack() {
      this.$router.go(-1)
    },
  },
}
</script>
<style lang="scss" scoped>
@import "./common/table.scss";
.customer-detail {
  width: 100%;
  background-color: #fff;
  .line {
    width: 100%;
    height: 10px;
    background-color: #f7f7f7;
  }
  .breadcrumb {
    display: flex;
    height: 50px;
    background-color: #ffffff;
    line-height: 50px;
    padding-left: 15px;
    i {
      line-height: 50px;
      margin-left: 15px;
    }
    .el-breadcrumb {
      line-height: 50px;
    }
  }
  .content {
    background-color: #ffffff;
    .back {
      height: 60px;
      line-height: 60px;
      margin-top: 10px;
      background-color: #ffffff;
      display: flex;
      justify-content: space-between;
      position: relative;
      border-bottom: 1px solid #eee;
      .left {
        margin-left: 40px;
        font-size: 18px;
        font-family: Adobe Heiti Std;
        font-weight: normal;
        color: rgba(51, 51, 51, 1);
      }
      span.go-back {
        margin-right: 30px;
        font-size: 14px;
        font-weight: 500;
        color: rgba(36, 85, 206, 1);
        cursor: pointer;
      }
    }
  }

}
</style>
